import DangerIcon from './danger.svg';
import EditPencilIcon from './edit-pencil.svg';
import PadhaiNamedLogoDark from './padhai-named-logo-dark.svg';
import PadhaiNamedLogo from './padhai-named-logo.svg';
import PwaDownloadIcon from './pwa-download-icon.svg';
import PwaIcon from './pwa-icon.png';
import TimerDarkIcon from './timer-dark.svg';
import TimerIcon from './timer.svg';
import WhatsappDisabledIcon from './whatsapp-disabled.svg';
import WhatsappWhiteIcon from './whatsapp-white.svg';

const IconSizes = {
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
};

const icons = {
  'pwa-download': PwaDownloadIcon,
  'whatsapp-white': WhatsappWhiteIcon,
  'edit-pencil': EditPencilIcon,
  'whatsapp-disabled': WhatsappDisabledIcon,
  'padhai-named-logo': PadhaiNamedLogo,
  'padhai-named-logo-dark': PadhaiNamedLogoDark,
  'pwa-icon': PwaIcon,
  danger: DangerIcon,
  timer: TimerIcon,
  'timer-dark': TimerDarkIcon,
};

export const Icon = ({
  name,
  size = 'md',
  customSize = null,
  className = '',
  ...props
}) => {
  const IconComponent = icons[name];
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <img
      src={IconComponent}
      width={customSize?.width || IconSizes[size]}
      height={customSize?.height || IconSizes[size]}
      alt={`${name} icon`}
      className={className}
      {...props}
    />
  );
};

// For backward compatibility
export {
  PwaDownloadIcon,
  WhatsappWhiteIcon,
  EditPencilIcon,
  WhatsappDisabledIcon,
  PadhaiNamedLogo,
  PadhaiNamedLogoDark,
};
